export var ContentConsentTypeEnum;
(function (ContentConsentTypeEnum) {
    ContentConsentTypeEnum["PersonalInformationAgreement"] = "Personal Information Agreement";
    ContentConsentTypeEnum["IndividualTermsAndConditions"] = "Individual Ts & Cs";
    ContentConsentTypeEnum["OrganisationalTermsAndConditions"] = "Organisational Ts & Cs";
    ContentConsentTypeEnum["AdminTermsAndConditions"] = "Admin terms and conditions";
    ContentConsentTypeEnum["DataPermissionsAgreement"] = "Data Permissions Agreement";
    ContentConsentTypeEnum["TermsAndConditions"] = "Terms & Conditions";
    ContentConsentTypeEnum["PermissionToShare"] = "Permission to Share Information";
    ContentConsentTypeEnum["PhotoPermissions"] = "Photo Permissions";
})(ContentConsentTypeEnum || (ContentConsentTypeEnum = {}));
export var MoreInformationTypeEnum;
(function (MoreInformationTypeEnum) {
    MoreInformationTypeEnum["Points"] = "Points";
    MoreInformationTypeEnum["IncomeStatements"] = "Income statements";
    MoreInformationTypeEnum["TakingChildAttendance"] = "Taking Child Attendance";
    MoreInformationTypeEnum["IdeasForMakingAProfit"] = "Ideas for making a profit";
    MoreInformationTypeEnum["LearningThroughPlay"] = "Learning through play";
    MoreInformationTypeEnum["TheDailyRoutine"] = "The daily routine";
    MoreInformationTypeEnum["DevelopingChildrenHolistically"] = "Developing children holistically";
    MoreInformationTypeEnum["TrackingProgress"] = "Tracking Progress";
    MoreInformationTypeEnum["Apply"] = "Apply";
    MoreInformationTypeEnum["Comply"] = "Comply";
})(MoreInformationTypeEnum || (MoreInformationTypeEnum = {}));
export var ContentTypeEnum;
(function (ContentTypeEnum) {
    ContentTypeEnum[ContentTypeEnum["ProgrammeRoutine"] = 1] = "ProgrammeRoutine";
    ContentTypeEnum[ContentTypeEnum["ProgrammeRoutineItem"] = 2] = "ProgrammeRoutineItem";
    ContentTypeEnum[ContentTypeEnum["ProgrammeRoutineSubItem"] = 3] = "ProgrammeRoutineSubItem";
    ContentTypeEnum[ContentTypeEnum["ProgressTrackingCategory"] = 4] = "ProgressTrackingCategory";
    ContentTypeEnum[ContentTypeEnum["ProgressTrackingSubCategory"] = 5] = "ProgressTrackingSubCategory";
    ContentTypeEnum[ContentTypeEnum["ProgressTrackingLevel"] = 6] = "ProgressTrackingLevel";
    ContentTypeEnum[ContentTypeEnum["ProgressTrackingSkill"] = 7] = "ProgressTrackingSkill";
    ContentTypeEnum[ContentTypeEnum["Theme"] = 8] = "Theme";
    ContentTypeEnum[ContentTypeEnum["ThemeDay"] = 9] = "ThemeDay";
    ContentTypeEnum[ContentTypeEnum["StoryBook"] = 10] = "StoryBook";
    ContentTypeEnum[ContentTypeEnum["StoryBookParts"] = 11] = "StoryBookParts";
    ContentTypeEnum[ContentTypeEnum["StoryBookPartQuestion"] = 12] = "StoryBookPartQuestion";
    ContentTypeEnum[ContentTypeEnum["Activity"] = 13] = "Activity";
    ContentTypeEnum[ContentTypeEnum["Consent"] = 14] = "Consent";
    ContentTypeEnum[ContentTypeEnum["Connect"] = 27] = "Connect";
    ContentTypeEnum[ContentTypeEnum["ConnectItem"] = 28] = "ConnectItem";
    ContentTypeEnum[ContentTypeEnum["MoreInformation"] = 15] = "MoreInformation";
    ContentTypeEnum[ContentTypeEnum["ClassroomBusinessResource"] = 39] = "ClassroomBusinessResource";
})(ContentTypeEnum || (ContentTypeEnum = {}));
//# sourceMappingURL=content-types.js.map